import { Vector3, Mesh } from "three";

export interface WallConfig
{
	isSideWall : boolean;
	id         : string;
	normal     : Vector3;
	original   : Mesh;
	current    : Mesh;
}

export class Wall
{
	public id         : string;
	public normal     : Vector3;
	public isSideWall : boolean;
	public original   : Mesh; // todo rename to originalMesh
	public current    : Mesh; // todo rename to currentMesh

	constructor(config:WallConfig)
	{
		this.id         = config.id;
		this.normal     = config.normal;
		this.isSideWall = config.isSideWall;
		this.original   = config.original;
		this.current    = config.current;

		this.current.castShadow = true;
	}
}